export interface Filter {
  field: string;
  label: string;
  multiple?: boolean;
  availableOperators?: ConditionOperatorsEnum[];
  defaultOperator?: ConditionOperatorsEnum;
  isSelect?: boolean;
  selectOptions?: SelectOption[];
}

export interface SelectedFilter extends Filter {
  operator: ConditionOperatorsEnum;
  value?: string;
}

export interface SelectOption {
  value: string;
  label: string;
}

export enum ConditionOperatorsEnum {
  ICONTAINS = '~',
  ICONTAINS_NOT = '!~',
  IS = '=',
  IS_NOT = '!=',
}

export const conditionOperators = {
  [ConditionOperatorsEnum.ICONTAINS]: {
    label: 'CONDITION_OPERATORS.ICONTAINS_KEY',
    value: '__icontains',
  },
  [ConditionOperatorsEnum.ICONTAINS_NOT]: {
    label: 'CONDITION_OPERATORS.ICONTAINS_NOT_KEY',
    value: '__icontains!',
  },
  [ConditionOperatorsEnum.IS]: {
    label: 'CONDITION_OPERATORS.IS_KEY',
    value: '',
  },
  [ConditionOperatorsEnum.IS_NOT]: {
    label: 'CONDITION_OPERATORS.IS_NOT_KEY',
    value: '!',
  },
};

export const getOperatorByValue = (
  value: string
): ConditionOperatorsEnum | undefined => {
  return (Object.keys(conditionOperators) as ConditionOperatorsEnum[]).find(
    key => conditionOperators[key].value === value
  );
};

export const getDefaultAvailableOperators = (filter: Filter) => {
  if (filter.isSelect) {
    return [ConditionOperatorsEnum.IS, ConditionOperatorsEnum.IS_NOT];
  }
  return [
    ConditionOperatorsEnum.IS,
    ConditionOperatorsEnum.IS_NOT,
    ConditionOperatorsEnum.ICONTAINS,
    ConditionOperatorsEnum.ICONTAINS_NOT,
  ];
};
export const generateQueryFilters = (filters: SelectedFilter[]) =>
  filters.reduce((acc, filter) => {
    const { field, operator, value } = filter;

    if (value) {
      const key = `${field}${conditionOperators[operator]?.value}`;

      acc[key] = value;
    }

    return acc;
  }, {} as Record<string, string>);
